import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, StarActiveIcon } from 'assets/icons';
import { UserService } from 'services';
import moment from 'moment';
import ModalUpdateUser from './modal-update-user';
import ModalCreateUser from './modal-create-user';
import ModalSelectConsultationPlan from './select-consultation-plan';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Users extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Nombre',
			'Email',
			'Teléfono',
			'Plan',
			'Consultas Disponibles',
			''
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		user_id: null,
		plans: [],
		visible_create: false,
		visible_consultation_plan: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Usuarios',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await UserService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.users.rows,
			last_page: res.users.count,
			plans: res.plans || []
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el usuario?',async () => {
			await UserService.admin.delete({
				user_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado el usuario correctamente");
			this.load(true);
		});
	}

	changeConsultationPlan = (user_id: number) => {
		this.setState({
			user_id,
			visible_consultation_plan: true
		});
	}

	onCloseConsultationPlan = () => {
		this.setState({
			user_id: null,
			visible_consultation_plan: false
		},() => this.load(true));
	}
	
	add = () => {
		this.setState({
			visible_create: true
		});
	}

	onCloseCreate = () => {
		this.setState({
			visible_create: false
		},() => this.load(true));
	}

	render() {
		const { visible, visible_consultation_plan, visible_create } = this.state;

		return (
			<div id="admin-users">
				<Modal
		          className="modal-update-user"
		          visible={ visible }
		          title="Editar Usuario"
		          onClose={ () => this.onClose() }
		        >
		          <ModalUpdateUser
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-update-user"
		          visible={ visible_create }
		          title="Crear Usuario"
		          onClose={ () => this.onCloseCreate() }
		        >
		          <ModalCreateUser
		            onClose={ () => this.onCloseCreate() } />
		      	</Modal>

		      	<Modal
		          className="modal-view-plans"
		          visible={ visible_consultation_plan }
		          title="Ver plan"
		          onClose={ () => this.onCloseConsultationPlan() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalSelectConsultationPlan
		          	user_id={ this.state.user_id }
		            onClose={ () => this.onCloseConsultationPlan() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-3">
								<Input
									value={ this.state.form.search }
									name="search"
									placeholder="Buscar"
									label="Buscar por nombre o correo"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-6">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
							<div className="col-md-3 text-right">
								<button className="btn add-btn" onClick={ this.add }>
									<img src={ AddIcon } />
									<p>Nuevo</p>
								</button>
							</div>
						</div>
					</div>
				</div>

				<Table title="Usuarios registrados" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>
									<div className="container-star">
										{
											i.support && (
												<Tooltip title="Soporte">
													<img src={ StarActiveIcon } />
												</Tooltip>
											)
										}
										<p>{ i?.name + ' ' + i?.lastname }</p>
									</div>
								</td>
								<td>{ i.email }</td>
								<td>{ i.phone }</td>
								<td className="td-change" onClick={ () => this.changeConsultationPlan(i.id) }>{ i?.consultation_plan_user_admin?.plan?.name || 'Sin plan' }</td>
								<td>{ i?.remaining_consultations }</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									<Tooltip title="Editar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
											<img src={ EditIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Eliminar">
										<a className="link-icon link-red" href="#" onClick={ (e: any) => this.delete(e,i) }>
											<img src={ TrashIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Users);